import styled from "styled-components/macro";

export const StyledHoverMenu = styled.div`
  background: var(--grey-0);
  border-radius: 30px;
  display: none;
  padding: 6px;
  position: absolute;
  right: 5px;
  top: 5px;
  display: none;
  align-items: center;
  // width: 50px;
  // height: 20px;

  .action-icon {
    color: var(--menu-color);
    border-radius: 50%;
    cursor: pointer;
    padding: 6px;
    margin: 0 2px;

    svg {
      path {
        fill: currentcolor;
      }
    }

    &:hover {
      background: var(--grey-1);
      opacity: 1;
    }
  }
`;

export const StyledKeeper = styled.div`
  transition: all 200ms;
  background: var(--menu-color-fullscreen);
  border-radius: 10px;
  box-shadow: var(--default-drop-shadow);
  margin: 2px;
  margin-bottom: 15px;
  ${({ born }) => (born ? "min-height: 30px;" : "min-height:0;")}
  ${({ born }) => (born ? "height: auto;" : "height:0;")}
  ${({ born }) => (born ? "opacity: 1;" : "opacity: 0;")}
  padding: 10px;
  position: relative;
  overflow: hidden;
  color: var(--grey-0);
  font-family: "Inter";
  font-size: 16px;
  line-height: 120%;
  font-weight: 400;

  &:hover {
    ${StyledHoverMenu} {
      display: flex;
    }
  }

  &.killed {
    min-height: 0;
    height: 0;
    padding: 0;
    margin: 0;
  }
`;

export const StyledEditInput = styled.div`
  textarea {
    background: transparent;
    border: none;
    border-radius: 10px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    padding: 0px;
    width: calc(100% - 10px);
    resize: none;
    color: var(--grey-0);
    ::selection {
      background: var(--text-highlight);
    }
  }
`;
